import React from 'react';
import SEOHead from '@/components/marketing/SEOHead';
import PageHeader from '@/components/marketing/PageHeader';
import CTASection from '@/components/marketing/CTASection';
import FeatureCard from '@/components/marketing/FeatureCard';
import { FEATURES, FEATURE_GRID } from '@/data/site-content';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import { breadcrumbJsonLd } from '@/lib/jsonld';

export default function FeaturesIndex() {
  const jsonLd = breadcrumbJsonLd([
    { label: 'Home', path: '/' },
    { label: 'Features' },
  ]);
  return (
    <>
      <SEOHead path="/features" jsonLd={jsonLd} />
      <PageHeader breadcrumbs={[{ label: 'Features' }]} eyebrow="Platform features" title="The toolkit performance teams expect" subtitle="From source-level controls to fraud filtering and GEO targeting — honest tools, clearly described." />
      <section className="bg-[#F5F7FB]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
          <h2 className="font-display text-2xl font-bold text-slate-900">Feature overview</h2>
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {FEATURE_GRID.map((f, i) => <FeatureCard key={i} feature={f} />)}
          </div>
          <h2 className="font-display mt-16 text-2xl font-bold text-slate-900">Deep-dive features</h2>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-5">
            {FEATURES.map((f) => {
              const Icon = f.icon;
              return (
                <Link key={f.slug} to={`/features/${f.slug}`} className="group rounded-2xl bg-white border border-slate-900/10 p-6 shadow-[0_10px_30px_rgba(2,6,23,0.06)] transition-shadow hover:shadow-[0_20px_50px_rgba(2,6,23,0.10)]">
                  <div className="flex items-start justify-between">
                    <span className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-[#2563EB]/10 text-[#2563EB] border border-[#2563EB]/20">
                      <Icon className="h-5 w-5" />
                    </span>
                    <ArrowUpRight className="h-4 w-4 text-slate-300 group-hover:text-[#2563EB] transition-colors" />
                  </div>
                  <h3 className="font-display mt-4 text-lg font-bold text-slate-900">{f.title}</h3>
                  <p className="mt-2 text-sm text-slate-600 leading-relaxed">{f.short}</p>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
      <CTASection />
    </>
  );
}
